module.exports = __webpack_public_path__ + "static/img/ConcertProgram_Tudor-plays-Brecht_Bauermeister_15June1960.dce9f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/ConcertProgram_Tudor-plays-Brecht_Bauermeister_15June1960.jpg
// module id = SzR6
// module chunks = 0